import { SportsBar } from '@mui/icons-material';
import { Avatar, Badge, Box, Chip, Divider, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material';
import React, { Component } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { User } from './Types/Types';
import { getTimestamp } from './Types/Utility';

interface Props {
    users: User[],
    placeholderPrimary?: string | undefined,
    placeholderSecondary?: string | undefined,
    showTimestamp?: boolean,
}

class BuamaList extends Component<Props, {}> {
    render() {
        const { showTimestamp = false, users, placeholderPrimary = 'No koa Bier trunkn!', placeholderSecondary = 'I dat moi oas trinkn!'} = this.props;

        const getAvatar = (user : User) => {
            if (user.image.startsWith('hoff')) {
                return process.env.PUBLIC_URL + '/img/' + user.image;
            }
            return process.env.PUBLIC_URL + '/awards/' + user.image;
        }

        const getName = (user : User) => {
            return <Typography variant={'body1'}>{user.username}</Typography>;
        }
        const getAwardCounts = (user : User) => {
            if (!user?.awards) {
                return null;
            }
            return <>Ehrunga: {user?.awards.length}</>;
        }
        const getTimestampLabel = (user : User) => {
            if (user?.timestamp) {
                return getTimestamp(''+(user?.timestamp));
            }
            return '';
        }

        return (
            <React.Fragment>
                {(users.length > 0)
                    ? <Virtuoso data={users} itemContent={(index : number, user : User) => {
                        return <React.Fragment>
                            <ListItemButton key={"user-item-" + index}>
                                <ListItemAvatar>
                                    <Badge
                                        overlap="circular"
                                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                        badgeContent={user.rank}
                                        color={"success"}
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        <Avatar src={getAvatar(user)}/>
                                        <Box sx={{ position: 'absolute', bottom: '-10px', left: 0, width: '100%', display: 'grid', placeItems: 'center' }}>
                                            {user.group_id && <Chip label={user.group_shorthand} color="primary" size="small" sx={{ borderRadius: '3px', fontSize: '0.65em', textTransform: 'uppercase', height: '16px' }}/>}
                                        </Box>
                                    </Badge>
                                </ListItemAvatar>
                                <Box sx={{ display: 'flex', width: '100%' }}>
                                    <Box flexGrow={1}>
                                        <ListItemText
                                            primary={getName(user)}
                                            secondary={showTimestamp ? getTimestampLabel(user) : getAwardCounts(user)}
                                            secondaryTypographyProps={{}}
                                        />
                                    </Box>
                                    {(typeof user.total_beers !== 'undefined') && <Box flexShrink={1} alignSelf={"center"} sx={{ marginLeft: 1 }} title={'Biercounter: ' + user.total_beers}>
                                        <Chip icon={<SportsBar />} label={user.total_beers} color="primary" size={'small'}/>
                                    </Box>}
                                </Box>
                            </ListItemButton>
                            {index < (users.length - 1) && <Divider variant="inset" />}
                        </React.Fragment>;
                    }
                    }/>
                    :<Box sx={{ display: 'grid', placeItems: 'center', height: '100%', textAlign: 'center' }}>
                        <Box>
                            <Box><Typography variant={"h6"}>{placeholderPrimary}</Typography></Box>
                            <Box><Typography variant={"body1"}>{placeholderSecondary}</Typography></Box>
                        </Box>
                    </Box>}
            </React.Fragment>
        );
    }
}
export default BuamaList;